import React, {Component} from 'react';
import TextField from 'material-ui/TextField';
import SelectField from 'material-ui/SelectField';
import MenuItem from 'material-ui/MenuItem';
import RaisedButton from 'material-ui/RaisedButton';

const styles = {
    successColor: {
        color: "#1a1a1a",
    },
    errorColor: {
        color: "#F44336"
    },
};

class PhotoBlock extends Component {

    constructor(props){
        super(props);

        this.state = {
            // FotoBlok
            photoBlockDimensionValue: null,
            photoBlockNumber: 1,
        }
    }

    photoBlockChange(e) {
        this.setState({
            photoBlockDimensionValue: e.target.value,
        })
    }

    photoBlockSubmit(e){
        this.props.onChange1(this.state.photoBlockDimensionValue, this.props.number,this.state.photoBlockNumber);
    }

    render(){
        return(
            <div className="full-width">
                <div className="form-group">
                    <TextField
                        type="text"
                        hintText="(Sadece Rakamla)"
                        floatingLabelText="Fotoblok Ebat"
                        floatingLabelStyle={styles.successColor}
                        onChange={this.photoBlockChange.bind(this)}
                        value={this.state.photoBlockDimensionValue}
                    />
                </div>

                <div className="form-group">
                    <TextField
                        type="text"
                        hintText="Fotoblok Adeti"
                        floatingLabelText="Fotoblok Adeti"
                        floatingLabelStyle={styles.successColor}
                        onChange={(e) => (e.target.value <= 127) ? this.setState({photoBlockNumber: e.target.value}) : -1}
                        defaultValue={this.state.photoBlockNumber}
                        value={this.state.photoBlockNumber}
                    />
                </div>

                <div className="buttonDiv">
                    <RaisedButton
                        label="Ekle"
                        type="button"
                        onClick={this.photoBlockSubmit.bind(this)}
                        disabled={(this.state.photoBlockDimensionValue === null) ? "disabled":""}
                        icon={<i className="material-icons">add</i>}
                        primary={true} />
                </div>

            </div>
        );
    }

}


export default PhotoBlock;